import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  files: [],
  loading: false,
  error: null,
  uploadResult: [],
  deleteResult: {},
};

const fileSlice = createSlice({
  name: 'file',
  initialState,
  reducers: {
    fetchFiles: (state, action) => {
      state.loading = true;
    },
    fetchFilesSuccess: (state, action) => {
      state.files = action.payload.data;
      state.loading = false;
    },
    fetchFilesFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearFileError: (state) => {
      state.error = null;
    },
    uploadFiles: (state, action) => {
      state.loading = true;
    },
    uploadFilesSuccess: (state, action) => {
      state.uploadResult = action.payload.data;
      state.loading = false;
    },
    uploadFilesFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearUploadResult: (state) => {
      state.uploadResult = [];
    },
    deleteFile: (state, action) => {
      state.loading = true;
    },
    deleteFileSuccess: (state, action) => {
      state.deleteResult = action.payload.data;
      state.loading = false;
    },
    deleteFileFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearDeleteResult: (state) => {
      state.deleteResult = [];
    },
  },
});

export const selectFile = (state) => state.file;

export const {
  fetchFiles,
  fetchFilesSuccess,
  fetchFilesFailure,
  clearFileError,
  uploadFiles,
  uploadFilesSuccess,
  uploadFilesFailure,
  clearUploadResult,
  deleteFile,
  deleteFileSuccess,
  deleteFileFailure,
  clearDeleteResult,
} = fileSlice.actions;

export default fileSlice.reducer;